import api from ".";
import debug from "../debug";
import { decrypt, encrypt } from "../secure";
import { v4 as uuidv4 } from "uuid";
//import { getApiKey } from "../../components/common/getEnv";
import { GET_API_KEY, APP_ID, APP_VERSION } from "../constants/env-resolver";

/**
 * API Client for Simple and Encrypt-Decrypt API calls
 * @param {boolean} isEncrypted - true if the API call is encrypted
 * @param {boolean} isExternalBaseUrl - true if the API endpoint is external than conventional API endpoint
 * @param {string} externalBaseUrl - full endpoint URL like https://example.com/some-random-api
 * @param {number} customerId - used for key generation used for encryption and decryption, 'null' for intial API calls like verifyOtp, sendOtp, etc
 * @param {string} route - API route like api/v1/verifyOtp (without base URL,Without leading slash)
 * @param {object} payload - Payload to be posted to the API Endpoint (In encrypted API's case, payload will be stringified and encrypted)
 * @param {object} headers - Headers used to pass as the request headers like (authorization, customerId, Authorization etc)
 * @param {boolean} otherPayloadDetailsPresent - true if the payload contains other details like requestId, appVersion, appId, etc (only true for encrypted API's)
 * @param {string} method - "GET" or "POST" or "PUT" or "DELETE"
 * @param {Function} successFn - Single param callback takes decrypted response object as param
 * @param {Function} errorFn -  Single param callback takes error object as param
 * @param {Function} finallyFn - No param, finally clause in API call
 */
const SecureClient = ({
  isEncrypted = false,
  isExternalBaseUrl = false,
  externalBaseUrl = "",
  customerId = null,
  route = "",
  payload = {},
  otherPayloadDetailsPresent = false,
  headers = {},
  method = "POST",
  successFn = res => {
    debug("WATCH", `Response: `, res);
  },
  errorFn = err => {
    debug("ERROR", `Error: `, err);
  },
  finallyFn = () => {
    debug("WATCH", `Finally: `);
  },
}) => {
  const apiLoadingStarted = new Date().getTime();
  let APIPayloadToPost = {},
    APIEndptToPost = route;
  debug("REQUEST", ` ${method} /${route} `, payload);

  if (isEncrypted) {
    const encryptedPayload = {
      data: encrypt(customerId, payload),
    };
    if (otherPayloadDetailsPresent) {
      encryptedPayload["appId"] = APP_ID;
      encryptedPayload["appVersion"] = APP_VERSION;
      encryptedPayload["requestId"] = uuidv4();
    }
    APIPayloadToPost = encryptedPayload;
  } else {
    APIPayloadToPost = payload;
  }
  if (isExternalBaseUrl) {
    APIEndptToPost = externalBaseUrl;
  }
  api(APIEndptToPost, APIPayloadToPost, method, {
    ...headers,
    "x-api-key": GET_API_KEY,
  })
    .then(res => {
      let decrypted = {};
      if (isEncrypted) {
        const resEncStr = res.data && res.data.response;
        debug("RESPONSE", "Encrypted res", resEncStr, customerId, res.data);
        decrypted = decrypt(customerId, resEncStr);
        debug("RESPONSE", `${method} /${route} `, decrypted);
      } else {
        decrypted = res.data;
        debug("RESPONSE", `${method} /${route} `, decrypted);
      }
      successFn(decrypted);
    })
    .catch(err => {
      debug("ERROR", err);
      errorFn(err);
    })
    .finally(() => {
      const apiLoadingFinished = new Date().getTime();
      const timeTakenByAPI = apiLoadingFinished - apiLoadingStarted;
      // debug("WATCH", `END ${method} /${route}`, timeTakenByAPI, "ms");
      if (finallyFn) finallyFn();
    });
};

export default SecureClient;
